<wo-conditional-link
  [hasAccess]="true | ifHasPermission:'can manage sites'"
  [link]="id ? AppRoutingLinks.site(id) : undefined"
  [inMobile]="false"
>
  <ng-content/>
</wo-conditional-link>
